export const sumLengths = <T>(items: T[], getLength: (item: T) => number): number => {
  return items.reduce((acc, item) => acc + getLength(item), 0);
};
